import { OramaClient } from '@oramacloud/client'
import { batch } from '@preact/signals-core'
import type { RegisterSearchBoxParams } from '../SearchBox'
import { MODE_CLOUD, MODE_LOCAL } from '../const'
import { searchboxConfig as defaultConfig } from '../defaultConfig'
import { MANDATORY_CLIENT } from '../errors'
import * as $ from '../signal/searchbox'
import type { ColorScheme } from '../types'

export const checkParams = (params: RegisterSearchBoxParams) => {
  // it's a web component, ignore
  if (!params || params.container) return

  const searchBoxMode = params.oramaInstance instanceof OramaClient || params.cloudConfig ? MODE_CLOUD : MODE_LOCAL

  if (!params.oramaInstance && !params.cloudConfig) {
    throw new Error(MANDATORY_CLIENT)
  }

  batch(() => {
    $.show.value = Boolean(params.show)
    params.theme && ($.theme.value = params.theme)
    params.searchMode && ($.searchMode.value = params.searchMode)
    params.searchParams && ($.searchParams.value = params.searchParams)
    params.keepOpen && ($.keepOpen.value = params.keepOpen)
    $.showShowMoreLink.value = Boolean(params.showShowMoreLink)
    $.mode.value = searchBoxMode
    // we don't wanna check for ! because in that case if someone doesn't pass it it will set it to false
    if (params.keyboardNavigationHints === false) {
      $.keyboardNavigationHints.value = params.keyboardNavigationHints
    }
    params.resultsMap && $.setSearchResultsMap(params.resultsMap)

    if (params.colorScheme) {
      params.colorScheme !== 'system' && ($.colorScheme.value = params.colorScheme as ColorScheme)

      params.colorScheme === 'system' &&
        ($.colorScheme.value = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    }

    $.backdrop.value = Boolean(params.backdrop)
    params.oramaInstance && $.setOramaClient(params.oramaInstance)
    params.cloudConfig && $.setOramaClientFromCloudConfig(params.cloudConfig)
    params.onClose && ($.onClose.value = params.onClose)

    params.themeConfig &&
      ($.themeConfig.value = {
        '--font-primary': params.themeConfig['--font-primary'] ?? defaultConfig.ui.theme['--font-primary'],
        light: {
          ...defaultConfig.ui.theme.light,
          ...params.themeConfig.light
        },
        dark: {
          ...defaultConfig.ui.theme.dark,
          ...params.themeConfig.dark
        },
        system: {}
      })
    params.searchInputPlaceholder && ($.searchInputPlaceholder.value = params.searchInputPlaceholder)
    params.searchResultsPlaceholder && ($.searchResultsPlaceholder.value = params.searchResultsPlaceholder)
    params.noResultsTemplate && ($.noResultsTemplate.value = params.noResultsTemplate)
    params.showFullscreenOnMobile && ($.showFullscreenOnMobile.value = params.showFullscreenOnMobile)

    $.facetProperty.value = params.facetProperty || ''
    params.showResultIcon && ($.showResultIcon.value = params.showResultIcon)
    params.seeAllLink &&
      ($.seeAllLink.value = {
        url: params.seeAllLink.url || $.seeAllLink.value.url,
        label: params.seeAllLink.label || $.seeAllLink.value.label
      })
    params.setResultTitle && ($.setResultTitle.value = params.setResultTitle)
    params.renderItem && ($.renderItem.value = params.renderItem)
    params.setResultLink && ($.setResultLink.value = params.setResultLink)
  })
}
